import React from 'react'
import Filtercomponent from '../components/Filter/Filtercomponent'
import Breadcrumbs from '../utils/Breadcrumb'

export default function Filter() {
  return (
    <div>
            <Breadcrumbs />

        <Filtercomponent />
    </div>
  )
}
